import { render, staticRenderFns } from "./gestionesConRectificaciones.vue?vue&type=template&id=19c4f475&scoped=true"
import script from "./gestionesConRectificaciones.vue?vue&type=script&lang=js"
export * from "./gestionesConRectificaciones.vue?vue&type=script&lang=js"
import style0 from "./gestionesConRectificaciones.vue?vue&type=style&index=0&id=19c4f475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4f475",
  null
  
)

export default component.exports